const Setup = () => import('./Setup.vue')

const List = () => import('./pages/List.vue')

const routes = {
  component: Setup,
  path: '/parametros',
  meta: {
    label: 'Parâmetros Gerais'
  },
  children: [
    {
      path: '',
      component: List,
      name: 'setupList',
      meta: {
        label: 'Gerenciar Parâmetros',
        requiredPermission: {resource: 'setup', value: 'view'}
      }
    }
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/pages/setup/routes.js